import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import * as _ from 'lodash';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
import { ReportsService } from 'src/app/modules/cpg/services/reports.service';

@Component({
  selector: 'app-coupon-report',
  templateUrl: './coupon-report.component.html',
  styleUrls: ['./coupon-report.component.scss']
})
export class CouponReportComponent implements OnInit {

  public loginData: any;
  public selectedCouponBackDetails: any;

  public pageSize: any = [ {id: 1, value: 10}, {id: 2, value: 25}, {id: 3, value: 50}, {id: 4, value: 100}];

  public coupons: any = [];
  public couponsPageSize: number = 1;
  public couponsPage: number = 1;
  public couponsCount: number = 0;
  public couponsSortField: string = 'start_date'; // Default sort by start date
  public couponsSortType: string = 'desc'; // Default sort descending order
  public couponsLoading: boolean = false;

  public pageFilterData: any;

  constructor(
    private _router: Router,
    private _utilService: UtilService,
    private _reportsService: ReportsService
  ) {
    // THIS IS NOT USED NOW. USE THIS FOR SETTINGS PREVIOUSLY SELECTED PAGE SETTINGS
    this.selectedCouponBackDetails = this._router.getCurrentNavigation().extras.state;
  }

  ngOnInit(): void {
    this.getStorageData();
  }

  async getStorageData() {
    this.loginData = await this._utilService.getStorageData('C_LOGIN');

    // Set defaults
    this.couponsPageSize = this.pageSize[0].value;
    this.couponsPage = 1;
    //this.getCouponsReport(); // THIS IS CALLED FROM onfilterChange()
  }

  // Get coupon report
  getCouponsReport() {
    if (this.pageFilterData) {
      this.coupons = [];
      this.couponsCount = 0;
      this.couponsLoading = true;
      
      let getcouponsReportBody = {
        provider_type: this.loginData.user_details.provider_type,
        provider_id: this.loginData.user_details.provider_id,
        mfg_id: this.pageFilterData.manufacturer,
        brand_id: this.pageFilterData.brand,
        retailer_id: this.pageFilterData.retailer,
        store_id: this.pageFilterData.store,
        coupon_source: this.pageFilterData.coupon_source,
        coupon_status: this.pageFilterData.coupon_status,
        page: this.couponsPage,
        page_size: this.couponsPageSize,
        sort_field: this.couponsSortField,
        sort_type: this.couponsSortType
      };

      this._reportsService.getCouponsReport(this.loginData.token, getcouponsReportBody).subscribe(async getCouponsReportResponse => {
        this.couponsLoading = false;

        if (getCouponsReportResponse.status === true) { // Success
          this.coupons = getCouponsReportResponse.coupons;
          this.couponsCount = getCouponsReportResponse.total_count;

          // Get coupons sales data
          //this.getCouponsSalesReport(); NOT USED NOW
        } else {
          this._utilService.showToast(getCouponsReportResponse.message, '', 'error', {});
        }
      }, error => { // Error from getCouponsReport
        this.couponsLoading = false;
      });
    }
  }

  // Change sorting
  changeSorting(field: string) {
    if (this.coupons.length > 0) {
      if (this.couponsSortField == field) { // Same field - Change sort type
        if (this.couponsSortType == 'asc') {
          this.couponsSortType = 'desc';
        } else {
          this.couponsSortType = 'asc';
        }
      } else { // Different field - Set sort descending
        this.couponsSortType = 'desc';
      }

      this.couponsSortField = field;

      this.couponsPage = 1;
      this.getCouponsReport();
    }
  }

  // Page size change
  onPageSizeChange(event: any) {
    this.couponsPage = 1;
    this.getCouponsReport();
  }

  // Page change
  onCouponsPageChange(event: any) {
    this.couponsPage = event;
    this.getCouponsReport();
  }

  // On page filter change
  async onPageFilterChange(event: any) {
    this.pageFilterData = event;

    this.couponsPage = 1;
    this.getCouponsReport();
  }


}
